/// <amd-module name="Reporting/Visuals/LayoutComponents/Widgets/LayoutState" />
import { VisualSubtitleProps } from "Reporting/Visuals/VisualSubtitle";
import { VisualTitleProps } from "Reporting/Visuals/VisualTitle";
import { ChartComponentProps } from "Widgets/ChartComponent";
import { ScalarComponentProps } from "Widgets/ScalarComponent";
import { SubmetricsComponentProps } from "Widgets/SubmetricsComponent";

/** Contains information about error states */
export enum MessageType {
    NoData,
    AxFaultIn,
    SetIterationDates,
    Unconfigured,
    WidgetError,
    MissingPermissions
}

export function isErrorMessageType(messageType: MessageType): boolean {
    return messageType === MessageType.WidgetError;
}

/** Contains information about status of widget component */
export interface LayoutStatus {
    /** boolean for recording message state */
    showMessage?: boolean;

    /** error message */
    message?: string;

    /** enum to describe type of error */
    messageType?: MessageType;
}

/** Contains information about metadata to be displayed on the widget */
export interface LayoutData {
    /** Contains data needed for rendering title. */
    title: VisualTitleProps;

    /** Contains data needed for rendering subtitle. */
    subtitle?: VisualSubtitleProps;

    /** Contains data needed for rendering scalar. */
    scalarData?: ScalarComponentProps;

    /** Contains data needed for rendering chart. */
    chartData?: ChartComponentProps;

    /** Contains data needed for submetrics. */
    submetricsData?: SubmetricsComponentProps;

    /** Contains data quality warnings */
    warningsData?: string[];
}

/**
 * Contains live data needed to render supported layout components.
 */
export interface LayoutState extends LayoutStatus, LayoutData {}

// Updates state based on message type
export function packMessageAsState(messageType: MessageType, message?: string): LayoutState {
    return {
        title: { text: "" },
        subtitle: undefined,
        scalarData: undefined,
        chartData: undefined,
        submetricsData: undefined,
        showMessage: true,
        messageType: messageType,
        message: message
    };
}
